export default __webpack_public_path__ + "static/sawandsawblades-65adb4022db01fa4c93c481a586cc9eb.png";